<template>
  <section>
    <v-dialog
      v-model="modalAction"
      max-width="1200px"
      scrollable
      @keydown="executeCloseModalMaintainers"
      @click:outside="executeCloseModalMaintainers"
    >
      <v-card>
        <div class="p-4 pb-0">
          <h5>
            Mantenedor de {{ getTitleFromIsProjectOrPresale }}
            {{ getCodeFromIsProjectOrPresale }}
          </h5>
        </div>
        <hr />
        <v-card-text>
          <maintainer-documents
            :isProject="isProject"
            :isPresale="isPresale"
            @updateNameDocumentDeleted="$emit('updateNameDocumentDeleted')"
            @folderCreatedOrUpdated="$emit('folderCreatedOrUpdated')"
          ></maintainer-documents>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalMaintainers"
          >
            <small> Cerrar </small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import MaintainerDocuments from "../maintaners/index.vue";
export default {
  components: { MaintainerDocuments },
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalMaintainers: {
      type: Function,
      default: () => {},
    },
    isProject: {
      type: Boolean,
      default: false,
    },
    isPresale: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    executeCloseModalMaintainers($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.closeModalMaintainers($event);
      }
    },
  },
  computed: {
    getTitleFromIsProjectOrPresale() {
      if (this.isProject) {
        return "Proyecto";
      }
      if (this.isPresale) {
        return "Preventa";
      }
      return "-";
    },
    getCodeFromIsProjectOrPresale() {
      if (this.isProject) {
        return this.getCodeProjectFromParamsOrQuery;
      }
      if (this.isPresale) {
        return this.$route.params.codePresale;
      }
      return "-";
    },
    getCodeProjectFromParamsOrQuery(){
      return this.$route.params.codigoProyecto || this.$route.query.code  
    }
  },
};
</script>

<style></style>
